(function (angular) {
  "use strict";

  angular.module("app").service("CardsApi", CardsApi);

  CardsApi.$inject = ["settings", "$resource", "extendResource"];

  function CardsApi(settings, $resource, extendResource) {
    var resource = $resource(settings.apiBase + "/cards");

    return extendResource(resource);
  }
})(angular);
